export default __webpack_public_path__ + "static/media/angpao-cn.e155ebd9.webp";